import React from "react";
import { BtnEnviar, ContainerInformacion } from "./localStyle";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";

const ModalInformacion = () => {

  const onChangeInput = (e) => {
    console.log(e);
  };

  return (
    <React.Fragment>
      <ContainerInformacion>
        <InputV1
          inputType="text"
          errorStr={"El email es requerido"}
          placeholderText={"gabr****@gmail.com"}
          onChange={onChangeInput}
          className={"customCss"}
        //   checkError={checkError}
          isRequired={true}
          name="email"
        />
        <BtnEnviar className={"rb16l bgc-primary c-white"}>
            Enviar
        </BtnEnviar>
      </ContainerInformacion>
    </React.Fragment>
  );
};

export default ModalInformacion;
